import { useQuery } from 'react-query';
import { authFetch } from '../../CommonUtils/authFetch';
import { urlWithParams } from '../../CommonUtils/urlWithParams';
import { queryKeys } from './queryKeys';

export const FETCH_CLIENT_START_PAGE_ENDPOINT = '/Consumer/ClientStart';

export enum WorkflowEnum {
  Retirement = 'RetirementWorkflow',
  Education = 'EducationWorkflow',
  DebtManagement = 'DebtManagementWorkflow',
  HomePurchase = 'HomePurchaseWorkflow',
  EmergencyFund = 'EmergencyFundWorkflow',
  LargePurchase = 'LargePurchaseWorkflow',
  Comprehensive = 'ComprehensiveWorkflow',
  FinancialAccounts = 'FinancialAccountsWorkflow',
  HealthCare = 'HealthCareWorkflow',
  RiskTolerance = 'RiskToleranceWorkflow',
  AssetBucketing = 'AssetBucketingWorkflow',
  BeFi20 = 'BeFi20Workflow',
  EstatePlanning = 'EstatePlanningWorkflow',
  Decumulation = 'DecumulationWorkflow',
  PulseCheck = 'PulseCheckWorkflow',
  CharitableGiving = 'CharitableGivingWorkflow',
}

export interface WorkflowTileDTO {
  name: WorkflowEnum;
  markAsCompleted: boolean;
}

interface FetcherParams {
  clientId: string;
}

export const fetchClientStartPage = async ({
  clientId,
}: FetcherParams): Promise<WorkflowTileDTO[]> =>
  authFetch(urlWithParams(FETCH_CLIENT_START_PAGE_ENDPOINT, { clientId }));

interface QueryParams {
  clientId: string;
}

export const useClientStartPageQuery = ({ clientId }: QueryParams) => {
  return useQuery(
    queryKeys.clientStartPage(clientId),

    () => fetchClientStartPage({ clientId }),

    {
      cacheTime: 0,
    },
  );
};
